import './App.css';
import ContactForm from "../src/components/ContactForm"

function App() {
  return (
    <div className="">
      {<ContactForm/>}
    </div>
  );
}

export default App;
